import React from 'react';
import { Helmet } from 'react-helmet';
import { Dropdown, Loader } from 'semantic-ui-react';

// Workspaces
// @ts-ignore
import { ErrorBoundary } from 'workspaces/redux-error-boundary';

// Global Components
// @ts-ignore
import CurrentSeasonInProgressGate from 'components/CurrentSeasonInProgressGate';
// @ts-ignore
import ErrorBoundaryAlert from 'components/ErrorBoundaryAlert';
// @ts-ignore
import ErrorGate from 'components/ErrorGate';
// @ts-ignore
import LoadingGate from 'components/LoadingGate';
import RoleGate from 'components/RoleGate';
// @ts-ignore
import Online from 'components/Online';
// @ts-ignore
import PageTitleAndFilters from 'components/PageTitleAndFilters';
// @ts-ignore
import PageWrapper from 'components/PageWrapper';
// @ts-ignore
import SubmittingIndicator from 'components/SubmittingIndicator';
import SelectedTimesheetGroupNameValue from 'components/SelectedTimesheetGroupNameValue';
import SelectedTimesheetIsUnapprovedGate from 'components/SelectedTimesheetIsUnapprovedGate';
import SelectedTimesheetPersonFirstNameValue from 'components/SelectedTimesheetPersonFirstNameValue';
import SelectedTimesheetPersonLastNameValue from 'components/SelectedTimesheetPersonLastNameValue';
import SelectedTableCellRowsClearDropdownItem from 'components/SelectedTableCellRowsClearDropdownItem';
import SelectedTableCellsBulkActionsDropdown from 'components/SelectedTableCellsBulkActionsDropdown';
import ScrollToSelectedTableRow from 'components/ScrollToSelectedTableRow';
import TimesheetEntriesDeleteDropdownItem from 'components/TimesheetEntriesDeleteDropdownItem';
import TimesheetTimesheetEntriesErrorsButton from 'components/TimesheetTimesheetEntriesErrorsButton';
import TimesheetImportEnabledGate from 'components/TimesheetImportEnabledGate';

// Child Components
// @ts-ignore
import {
    ADMIN,
    MANAGER,
    ASSISTANT_MANAGER,
    PAYROLL
} from 'components/RoleGate/constants';
import TimesheetApproveModal from '../../components/TimesheetApproveModal';
// @ts-ignore
import CreateTimesheetEntriesButton from './components/CreateTimesheetEntriesButton';
import ImportTimesheetEntriesButton from './components/ImportTimesheetEntriesButton';
// @ts-ignore
import ResetSelectedTableCellsOnUmnount from './components/ResetSelectedTableCellsOnUmnount';
import TimesheetAutoDiscardUnsavedValues from './components/TimesheetAutoDiscardUnsavedValues';
// @ts-ignore
import TimesheetGroupByDropdown from './components/TimesheetGroupByDropdown';
// @ts-ignore
import TimesheetRequest from './components/TimesheetRequest';
// @ts-ignore
import TimesheetTimesheetEntriesForm from './components/TimesheetTimesheetEntriesForm';
import TimesheetExitConfirmation from './components/TimesheetExitConfirmation';

// Environment
const { REACT_APP_PROJECT_NAME } = process.env;

interface Props {
    match: {
        params: {
            timesheetId: string;
        };
    };
}

class Timesheet extends React.PureComponent<Props> {
    get timesheetId(): number {
        const {
            match: {
                params: { timesheetId }
            }
        } = this.props;
        return Number(timesheetId);
    }

    render(): React.ReactElement {
        return (
            <RoleGate
                requiredRoles={[ADMIN, MANAGER, ASSISTANT_MANAGER, PAYROLL]}
            >
                <ErrorBoundary
                    namespace="Timesheet"
                    FallbackComponent={<ErrorBoundaryAlert />}
                >
                    <Helmet>
                        <title>
                            {'Timesheet - '}
                            {REACT_APP_PROJECT_NAME}
                        </title>
                    </Helmet>
                    <ResetSelectedTableCellsOnUmnount />
                    <Online>
                        <TimesheetRequest timesheetId={this.timesheetId} />
                    </Online>
                    <ErrorGate namespace="TIMESHEET_LOAD">
                        <LoadingGate
                            namespace="TIMESHEET_LOAD"
                            LoadingComponent={
                                <PageWrapper>
                                    <Loader active inline="centered" />
                                </PageWrapper>
                            }
                        >
                            <TimesheetExitConfirmation />
                            <ScrollToSelectedTableRow />
                            <TimesheetAutoDiscardUnsavedValues />
                            <PageTitleAndFilters
                                title={
                                    <React.Fragment>
                                        {'Timesheet: '}
                                        <SelectedTimesheetGroupNameValue />
                                        <SelectedTimesheetPersonFirstNameValue />{' '}
                                        <SelectedTimesheetPersonLastNameValue />
                                    </React.Fragment>
                                }
                                subtitle={
                                    <SubmittingIndicator namespace="TIMESHEET_TIMESHEET_ENTRIES_MANAGE" />
                                }
                                backTo="/organization/time/timesheets"
                                CustomSearch={null}
                                Button={
                                    <RoleGate
                                        requiredRoles={[
                                            ADMIN,
                                            MANAGER,
                                            ASSISTANT_MANAGER
                                        ]}
                                    >
                                        <SelectedTimesheetIsUnapprovedGate>
                                            <React.Fragment>
                                                <TimesheetImportEnabledGate>
                                                    <ImportTimesheetEntriesButton />
                                                </TimesheetImportEnabledGate>
                                                <CreateTimesheetEntriesButton />
                                            </React.Fragment>
                                        </SelectedTimesheetIsUnapprovedGate>
                                    </RoleGate>
                                }
                                FirstActionButton={
                                    <RoleGate
                                        requiredRoles={[
                                            ADMIN,
                                            MANAGER,
                                            ASSISTANT_MANAGER
                                        ]}
                                    >
                                        <SelectedTableCellsBulkActionsDropdown
                                            DropdownMenu={
                                                <Dropdown.Menu>
                                                    <SelectedTableCellRowsClearDropdownItem />
                                                    <SelectedTimesheetIsUnapprovedGate>
                                                        <TimesheetEntriesDeleteDropdownItem />
                                                    </SelectedTimesheetIsUnapprovedGate>
                                                </Dropdown.Menu>
                                            }
                                        />
                                    </RoleGate>
                                }
                                SecondActionButton={
                                    <TimesheetTimesheetEntriesErrorsButton />
                                }
                                ThirdActionButton={<TimesheetGroupByDropdown />}
                                workType
                                workTypeMultiple
                                person
                                personMultiple
                                compact
                            />
                            <TimesheetTimesheetEntriesForm
                                timesheetId={this.timesheetId}
                            />
                        </LoadingGate>
                    </ErrorGate>
                    <CurrentSeasonInProgressGate>
                        <TimesheetApproveModal />
                    </CurrentSeasonInProgressGate>
                </ErrorBoundary>
            </RoleGate>
        );
    }
}

export default Timesheet;
